var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.703 5.728a.824.824 0 00-1.188 0L7.949 9.39 4.384 5.728a.824.824 0 00-1.188 0 .88.88 0 000 1.22l4.16 4.274a.824.824 0 001.187 0l4.16-4.273a.88.88 0 000-1.221","fillRule":"evenodd"}));
}

ArrowDown.defaultProps = {"width":"16","height":"16"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
